import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { Flex, Grid, theme } from "antd";
import dayjs from "dayjs";
import FixturesApi from "./../../api/FixturesApi.js";
import Loader from "./../../components/loader/Loader.js";
import MatchCards from "./../../components/matchCards/MatchCards.js";
import { withScrollToTop } from "./../../hoc";
import { EVENT_ACTIONS, track } from "./../../lib/gtag.js";
import MatchesDatePicker from "./matchesDatePicker/MatchesDatePicker";
const { useBreakpoint } = Grid;
const API_CALL_TIMEOUT = 3e3;
const Matches = ({ banner = null }) => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [live, setLive] = useState(false);
  const timerRef = useRef();
  const getFixturesByDateApi = FixturesApi.getFixturesByDate();
  const getFixturesLiveApi = FixturesApi.getFixturesLive();
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  useEffect(() => {
    if (live) {
      setLoading(true);
      getFixturesLive();
    } else {
      if (selectedDate) {
        setLoading(true);
        getFixturesByDate(selectedDate);
      }
    }
    return () => {
      getFixturesLiveApi.cancel();
      getFixturesByDateApi.cancel();
      clearTimeout(timerRef.current);
    };
  }, [live, selectedDate]);
  const handleLiveClick = useCallback(() => {
    setLive(!live);
    if (!live)
      setSelectedDate(dayjs());
  }, [live]);
  const handleDateChange = useCallback((date) => {
    setSelectedDate(date);
    setLive(false);
  }, []);
  const getFixturesByDate = async (date) => {
    var _a, _b;
    clearTimeout(timerRef.current);
    try {
      const response = await getFixturesByDateApi.call(
        date.format("MM-DD-YYYY")
      );
      setLeagues((_b = (_a = response.data) == null ? void 0 : _a.leagues) != null ? _b : []);
      if (selectedDate.isSame(dayjs(), "day")) {
        timerRef.current = setTimeout(() => {
          getFixturesByDate(date);
        }, API_CALL_TIMEOUT);
      }
    } catch (error) {
      console.error("Error fetching fixtures:", error);
    } finally {
      setLoading(false);
    }
  };
  const getFixturesLive = async () => {
    var _a, _b;
    clearTimeout(timerRef.current);
    try {
      const response = await getFixturesLiveApi.call();
      setLeagues((_b = (_a = response.data) == null ? void 0 : _a.leagues) != null ? _b : []);
      timerRef.current = setTimeout(() => {
        getFixturesLive();
      }, API_CALL_TIMEOUT);
    } catch (error) {
      console.error("Error fetching fixtures:", error);
    } finally {
      setLoading(false);
    }
  };
  const matchCardClickCallback = () => {
    track(
      live ? EVENT_ACTIONS.LEAGUE_DETAILS_FROM_LIVE : EVENT_ACTIONS.LEAGUE_DETAILS_FROM_MATCHES
    );
  };
  const fixtureClickCallback = () => {
    track(
      live ? EVENT_ACTIONS.MATCH_DETAILS_FROM_LIVE : EVENT_ACTIONS.MATCH_DETAILS_FROM_MATCHES
    );
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    screens.md && banner,
    /* @__PURE__ */ jsxs(
      Flex,
      {
        vertical: true,
        gap: screens.md ? 24 : 16,
        className: "matches",
        style: {
          padding: 0,
          backgroundColor: token.colorBgBase,
          overflow: "hidden",
          borderRadius: 0
        },
        children: [
          /* @__PURE__ */ jsx(
            MatchesDatePicker,
            {
              live,
              onLiveClick: handleLiveClick,
              selectedDate,
              setSelectedDate: handleDateChange
            }
          ),
          loading ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsx(
            MatchCards,
            {
              leagues,
              virtualize: false,
              fixtureClickCallback,
              matchCardClickCallback
            }
          )
        ]
      }
    )
  ] });
};
var stdin_default = withScrollToTop(Matches);
export {
  stdin_default as default
};
